import { render, staticRenderFns } from "./EnemyPrincipal.vue?vue&type=template&id=b7ddf91a&scoped=true"
import script from "./EnemyPrincipal.vue?vue&type=script&lang=js"
export * from "./EnemyPrincipal.vue?vue&type=script&lang=js"
import style0 from "./EnemyPrincipal.vue?vue&type=style&index=0&id=b7ddf91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ddf91a",
  null
  
)

export default component.exports